export type DurationMinutes = 5 | 10 | 15 | 20;
export type EndSound = 'none' | 'chime' | 'gong';

export interface Settings {
  defaultDuration: DurationMinutes;
  endSound: EndSound;
}

export interface Stats {
  totalSessions: number;
  totalMinutes: number;
  lastSession: string | null;
  /** Sorted unique YYYY-MM-DD dates a candle was lit. Used to compute
   * the current streak without storing one timestamp per session. */
  sessionDates: string[];
  /** Highest consecutive-day streak achieved, ever. */
  longestStreak: number;
}

export const DEFAULT_SETTINGS: Settings = {
  defaultDuration: 10,
  endSound: 'chime',
};

export const DEFAULT_STATS: Stats = {
  totalSessions: 0,
  totalMinutes: 0,
  lastSession: null,
  sessionDates: [],
  longestStreak: 0,
};

export const DURATIONS: DurationMinutes[] = [5, 10, 15, 20];

/**
 * A short optional note the visitor leaves at the end of a session.
 * Stored locally, never uploaded. The keepsake is private; the value
 * is in the act of writing it.
 */
export interface Reflection {
  date: string;
  durationMinutes: number;
  note: string;
}
